import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "51",
  height: "51",
  fill: "none",
  viewBox: "0 0 51 51"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FF5100",
      "stroke-width": "1.505",
      d: "M18.694 12.987a13.87 13.87 0 0 0-7.336 12.236c0 7.659 6.209 13.868 13.868 13.868s13.868-6.209 13.868-13.868c0-5.297-2.97-9.901-7.336-12.236m-6.532 7.341V8.092m24.473 17.13c0 13.517-10.957 24.474-24.473 24.474S.753 38.739.753 25.223 11.71.75 25.226.75s24.473 10.957 24.473 24.473Z"
    }, null, -1)
  ]))]))
}
export default { render: render }